import React, { useState } from 'react';
import { supabase } from './supabase';

export default function Auth({ embedded = false }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    setMessage(null);

    try {
      if (isLogin) {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
      } else {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        setMessage('Bestätigungs-E-Mail gesendet! Bitte prüfe dein Postfach.');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const Wrapper = embedded ? React.Fragment : ({ children }) => (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px'
    }}>
      <div style={{
        background: 'white', borderRadius: '20px', padding: '48px',
        width: '100%', maxWidth: '420px', boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
      }}>
        {children}
      </div>
    </div>
  );

  return (
    <Wrapper>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{ fontSize: '2rem', fontWeight: '800', marginBottom: '8px' }}>
            recrui<span style={{ color: '#667eea' }}>fly</span>
          </div>
          <p style={{ color: '#666', fontSize: '0.95rem' }}>
            {isLogin ? 'Willkommen zurück!' : 'Konto erstellen'}
          </p>
        </div>

        {error && (
          <div style={{
            padding: '12px 16px',
            background: '#fee2e2',
            borderRadius: '8px',
            color: '#dc2626',
            fontSize: '0.9rem',
            marginBottom: '20px'
          }}>
            {error}
          </div>
        )}

        {message && (
          <div style={{
            padding: '12px 16px',
            background: '#f0fdf4',
            borderRadius: '8px',
            color: '#166534',
            fontSize: '0.9rem',
            marginBottom: '20px'
          }}>
            {message}
          </div>
        )}

        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '0.9rem' }}>
            E-Mail
          </label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="max@beispiel.de"
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '2px solid #e5e5e5',
              borderRadius: '8px',
              fontSize: '1rem',
              outline: 'none'
            }}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          />
        </div>

        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', fontWeight: '600', marginBottom: '6px', fontSize: '0.9rem' }}>
            Passwort
          </label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="••••••••"
            style={{
              width: '100%',
              padding: '12px 16px',
              border: '2px solid #e5e5e5',
              borderRadius: '8px',
              fontSize: '1rem',
              outline: 'none'
            }}
            onKeyDown={e => e.key === 'Enter' && handleSubmit()}
          />
        </div>

        <button
          onClick={handleSubmit}
          disabled={loading || !email || !password}
          style={{
            width: '100%',
            padding: '14px',
            background: loading ? '#ccc' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            fontSize: '1rem',
            fontWeight: '700',
            cursor: loading ? 'not-allowed' : 'pointer',
            marginBottom: '16px'
          }}
        >
          {loading ? '⏳ Laden...' : isLogin ? '→ Einloggen' : '→ Registrieren'}
        </button>

        <div style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
          {isLogin ? 'Noch kein Konto?' : 'Schon ein Konto?'}{' '}
          <span
            onClick={() => { setIsLogin(!isLogin); setError(null); setMessage(null); }}
            style={{ color: '#667eea', fontWeight: '600', cursor: 'pointer' }}
          >
            {isLogin ? 'Registrieren' : 'Einloggen'}
          </span>
        </div>
    </Wrapper>
  );
}